import { useEffect } from 'react';
import classNames from 'classnames';

import { useToastSlice } from '@hcs/toast';
import { OrderItemStatus } from '@hcs/types';

import { useOrderProgress } from '../../../hooks/useOrderProgress';
import { StatusGroup } from '../../../types';

import styles from './OrderProgressDetails.module.css';

type OrderProgressDetailsProps = {
  orderNumber: string;
  orderId: number;
  statusGroups: StatusGroup[];
};

export const OrderProgressDetails = (props: OrderProgressDetailsProps) => {
  const { orderNumber, statusGroups, orderId } = props;
  const {
    actions: { toastOpen },
  } = useToastSlice();
  const {
    isSuccess,
    data: orderProgressData,
    isError: orderProgressIsError,
    error: orderProgressError,
  } = useOrderProgress(orderId);

  useEffect(() => {
    if (orderProgressIsError) {
      toastOpen({
        type: 'error',
        title: orderProgressError.message,
      });
    }
  }, [orderProgressIsError, orderProgressError, toastOpen]);

  return (
    <div>
      {orderProgressData &&
        isSuccess &&
        Object.keys(orderProgressData).length > 0 &&
        statusGroups.map((statusGroup: StatusGroup) => {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          const allProgressKeys = Object.keys(
            orderProgressData,
          ) as OrderItemStatus[];
          const statusCount = allProgressKeys.reduce(
            (count, orderProgressKey) => {
              const progressData = orderProgressData[orderProgressKey];
              if (
                progressData &&
                statusGroup.includedStatuses.indexOf(orderProgressKey) !== -1
              ) {
                count = progressData;
              }
              return count;
            },
            0,
          );
          let rowClassName = styles.Row;
          if (
            statusGroup.includedStatuses.indexOf(OrderItemStatus.Complete) !==
            -1
          ) {
            rowClassName = classNames(styles.Row, styles.Complete);
          }
          return (
            <div
              className={rowClassName}
              key={`${orderNumber}_${statusGroup.name}`}
            >
              <div className={styles.Label}>{statusGroup.name}</div>
              <div className={styles.NumberOfItems}>{statusCount}</div>
            </div>
          );
        })}
    </div>
  );
};
